<template>
  <FormSelect v-model="value" :options="options" />
</template>
<script>
export default {
  props: ["column", "modelValue"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    options() {
      return (this.column?.enum || []).map(item=>({
        value: item,
        text: item,
      }));
    },
  },
}
</script>
